<script lang="ts">
	// Import 1
	import '@fontsource-variable/outfit';
	// Import 2
	import '$lib/assets/css/app.css';
	// Import 3

	import {
		PUBLIC_DARK_COLOR_ONE,
		PUBLIC_DARK_COLOR_PRIMARY,
		PUBLIC_DARK_COLOR_SECONDARY,
		PUBLIC_DARK_COLOR_THREE,
		PUBLIC_DARK_COLOR_TWO,
		PUBLIC_LIGHT_COLOR_ONE,
		PUBLIC_LIGHT_COLOR_PRIMARY,
		PUBLIC_LIGHT_COLOR_SECONDARY,
		PUBLIC_LIGHT_COLOR_THREE,
		PUBLIC_LIGHT_COLOR_TWO
	} from '$env/static/public';

	const rootStyle = `<style>
	:root {
			--font-size: 17;
			--container: 1440;
			--border-radius-base: 1.4rem;

			--text-color: #000000;
			--color-one: ${PUBLIC_LIGHT_COLOR_ONE};
			--color-two: ${PUBLIC_LIGHT_COLOR_TWO};
			--color-three: ${PUBLIC_LIGHT_COLOR_THREE};
			--color-primary: ${PUBLIC_LIGHT_COLOR_PRIMARY};
			--color-secondary: ${PUBLIC_LIGHT_COLOR_SECONDARY};
			--color-success: #19aa42;
			--color-danger: #d82c2c;
			--color-input-label: #1e293b;
			--text-weight: 500;
		}

		.dark {
			color-scheme: dark;
			--text-color: #daf5ff;
			--color-one: ${PUBLIC_DARK_COLOR_ONE};
			--color-two: ${PUBLIC_DARK_COLOR_TWO};
			--color-three: ${PUBLIC_DARK_COLOR_THREE};
			--color-primary: ${PUBLIC_DARK_COLOR_PRIMARY};
			--color-secondary: ${PUBLIC_DARK_COLOR_SECONDARY};
			--color-success: #92f4ae;
			--color-danger: #fba2a2;
			--color-input-label: #93b7be;
			--text-weight: 300;
		}</style>`;
</script>

<svelte:head>
	<!-- eslint-disable svelte/no-at-html-tags -->
	{@html rootStyle}
</svelte:head>
